const _public = {};

_public.fetch = params => fetch(params);

module.exports = _public;
